/* eslint-disable jira/filename-case */
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
export const PACKAGE_NAME_GASV3 = 'jiraForgeUi';
export const PACKAGE_NAME_BM3 = 'jiraforgeui';

export const MODULE_TYPE_TRIGGER = 'trigger';
export const MODULE_TYPE_EXTENSION = 'extension';

export const FORGE_SAMPLING_RATE = 10;

export const PERFORMANCE_KEYS: {
	readonly FORGE_MODULES: {
		readonly FETCH_TIME: 'jiraforgeui.forge-modules.fetch-time';
		readonly LOAD_TIME: 'jiraforgeui.forge-modules.load-time';
	};
	readonly REAL_TIME_ISSUE_EVENTS: {
		readonly INVOKE_TIME: 'jiraforgeui.real-time-issue-events.invoke-time';
	};
	readonly MARKS: {
		readonly TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK';
		readonly TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START';
		readonly ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END';
	};
} = {
	FORGE_MODULES: {
		FETCH_TIME: `${PACKAGE_NAME_BM3}.forge-modules.fetch-time`,
		LOAD_TIME: `${PACKAGE_NAME_BM3}.forge-modules.load-time`,
	},
	REAL_TIME_ISSUE_EVENTS: {
		INVOKE_TIME: `${PACKAGE_NAME_BM3}.real-time-issue-events.invoke-time`,
	},
	MARKS: {
		TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
		TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
		ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
		ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
		ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
		ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
		ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START:
			'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
		ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END:
			'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
		ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START:
			'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
		ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END:
			'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END',
	},
} as const;

export const UI_ACTIONS = {
	CLICKED: 'clicked',
	SELECTED: 'selected',
	CANCELED: 'canceled',
	ACTION_CLICKED: 'action clicked',
	COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
	PIN_UNPIN_CLICKED: 'pin-unpin clicked',
	REMOVE_CLICKED: 'remove clicked',
} as const;

export const OPERATIONAL_ACTIONS = {
	FAILED: 'failed',
	SUCCEEDED: 'succeeded',
	CALLED: 'called',
	INITIALIZED: 'initialized',
	EDIT_FAILED: 'edit failed',
	ACTION_FAILED: 'action failed',
	SAVE_FAILED: 'save failed',
	REMOVE_FAILED: 'remove failed',
	UPDATE_FAILED: 'update failed',
} as const;

export const TRACK_ACTIONS = {
	EDITED: 'edited',
	SAVED: 'saved',
	REMOVED: 'removed',
	ACTION_SUCCEED: 'action succeed',
	UPDATE_SUCCEED: 'update succeed',
} as const;
